// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationBar_wrapper__Y5r9F","badge":"LocationBar_badge__lxKxc","position":"LocationBar_position__1D6j2","btn":"LocationBar_btn__Y4tJU"};